import {SchemaWithClient} from '../types/SchemaWithClient';
import {Client} from '../services/Client';
import {NumberField} from '../components/Table/fields/NumberField';
import {TextField} from '../components/Table/fields/TextField';
import {AccommodationType} from '../types/entities/AccommodationType';
import {SetField} from "../components/Table/fields/SetField";
import {SPTextField} from "../components/Table/fields/SPTextField";
import {SPRichTextField} from "../components/Table/fields/SPRichTextField";
import {SPSelectField} from "../components/Table/fields/SPSelectField";
import {enumItems} from "./enumItems";
import {SPBooleanField} from "../components/Table/fields/SPBooleanField";
import {SPRateField} from "../components/Table/fields/SPRateField";
import {AccommodationContact} from "../components/Contacts/AccommodationContact";
import {AccommodationVenues} from "../components/Venues/AccommodationVenues";
import {Prices} from "../components/Accommodation/Prices";
import {AccommodationCorporateComponent} from "../components/LegalAndFinance/AccommodationCorporate";
import {SPNumberField} from "../components/Table/fields/SPNumberField";
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";
import {AccommodationAttachment} from "../components/Images/AccommodationAttachment";
import {AccommodationImages} from "../components/Images/AccommodationImages";
import {SelectField} from "../components/Table/fields/SelectField";
import {address} from "./address";
import {SPSetAddressField} from "../components/Table/fields/SPSetAddressField";
import {BooleanField} from "../components/Table/fields/BooleanField";
import {AccommodationCategoryImages} from "../components/Images/AccommodationCategoryImages";
import {
  AccommodationCategoryPrices,
  AccommodationCategoryCosts,
} from "../components/Prices/AccommodationCategoryPrices";

export const accommodationCategory: SchemaWithClient<any> = {
  name: 'Accommodation Category',
  pluralName: 'Accommodation Category',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Prices',
      name: 'prices',
      type: 'custom',
      renderer: AccommodationCategoryPrices,
      rendererType: 'prices',
    },
    {
      id: 3,
      label: 'Costs',
      name: 'costs',
      type: 'custom',
      renderer: AccommodationCategoryCosts,
      rendererType: 'prices',
    },
  ],
  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      name: 'general',
      hasDefaultButtons: true,
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Name',
              fieldRenderer: SPTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [

          ],
        },
        {
          width: 4,
          columns: [

          ],
        },
      ],
    },
    {
      id: 1,
      width: 12,
      label: 'Public Website',
      name: 'public_website',
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'pricing',
              name: 'Pricing',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'subheader',
              name: 'Subheader',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'capacity',
              name: 'Capacity',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'description_en',
              name: 'Description',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Pricing Rate',
              fieldRenderer: SPRateField,
              columnName: 'pricing_rate',
            },
            {
              name: 'Public Website Active',
              fieldRenderer: SPBooleanField,
              columnName: 'public_website_active',
            },
          ],
        },
      ],
    },


    {
      id: 6,
      width: 12,
      label: 'Prices',
      name: 'prices',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'prices',
              fieldRenderer: AccommodationCategoryPrices,
            },
          ],
        },
      ],
    },
    {
      id: 7,
      width: 12,
      label: 'Costs',
      name: 'costs',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'costs',
              fieldRenderer: AccommodationCategoryCosts,
            },
          ],
        },
      ],
    },
    {
      id: 8,
      width: 8,
      label: 'Images',
      name: 'images',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'images',
              fieldRenderer: AccommodationCategoryImages,
            },
          ],
        },
      ],
    },
  ],

  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    description_en: {
      name: 'Description',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },

    pricing: {
      name: 'Pricing',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    subheader: {
      name: 'Subheader',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    capacity: {
      name: 'Capacity',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    pricing_rate: {
      name: 'Pricing Rate',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPRateField,
      //fieldType: 'boolean',
      section: 'general',
    },

    public_website_active: {
      name: 'Public Website',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      section: 'general',
      defaultShow: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      defaultShow: false,
    },
  },
  client: new Client('/accommodation-categories'),
};
